import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const StackedAreaChart = () => {
  const options = {
    chart: {
      type: 'areaspline',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    },
    yAxis: {
      title: {
        text: '',
      },
      categories:['$5','$10','$15','$20', '$25','$30']
    },
    // plotOptions: {
    //   series: {
    //       pointStart: 2000
    //   },
    //   areaspline: {
    //       // fillOpacity: 0.5
    //   }
    // },
    plotOptions: {
      area: {
        stacking: 'normal',
        lineColor: '#BDA7EC',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#BDA7EC',
        },
      },
    },
    series: [
      {
        name: 'Subscription',
        data: [1, 3, 2, 4, 5, 2],
        color: '#6240C9',
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default StackedAreaChart;
